import { TypographyV3, type TypographyV3Props } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import getValues from '../utils/getValues';

interface ParagraphProps extends Omit<TypographyV3Props, 'children'> {
  readonly tx: MessageKey;
}

const values = getValues();

const P = ({ tx, ...props }: ParagraphProps): JSX.Element => {
  const t = useTranslations();
  return <TypographyV3 {...props}>{t.rich(tx, values)}</TypographyV3>;
};

export default P;
